import mitt from 'mitt';
import { createApp } from 'vue';
import App from './App.vue';
import logoutPlugin from './plugins/logoutPlugin.js';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import router from './router';
import store from './store';

// Import ResizeObserver fix
import './utils/resizeObserverFix.js';

// Import global white theme CSS
import './assets/styles/font-system.css'; // Add this line
import './assets/styles/white-theme.css'; // This imports the white theme CSS globally

import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

const emitter = mitt();
const app = createApp(App);

// your existing plugins
app.use(router);
app.use(store);
app.use(loadFonts);
app.use(logoutPlugin);
app.use(vuetify);

// global event bus
app.config.globalProperties.emitter = emitter;

app.mount('#app');
